import { mapValues } from '../../../lib/utilities';

const mapValuesWithKey = mapValues;
export const generateFeatureFlags = mapValuesWithKey;
